import React, { Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import GrokPoweredLogo from "../../assets/grok_new_powered.svg";
import useStyles from "./styles";
//Footer Component

const Footer = () => {
  const { footer } = useStyles();
  const currentYear = new Date().getFullYear();

  return (
    <Fragment>
      <Grid container className={footer}>
        <p>
           <span>© {currentYear}. All Rights Reserved</span>
          <img src={GrokPoweredLogo} alt="Grok powered" />
        </p>
      </Grid>
    </Fragment>
  );
};

export default Footer;
